(() => {
  if (window.hnUSStockEtaLoaded) return;
  window.hnUSStockEtaLoaded = true;
  const selector = '.hn-ship-now[data-hn-us-stock]';
  const nodes = () => [...document.querySelectorAll(selector)];
  const hide = (node) => {
    node.hidden = true;
    node.style.setProperty('display', 'none', 'important');
  };
  function refresh(node) {
    const form = document.getElementById(node.dataset.hnForm);
    const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
    const checkedAt = Date.parse(node.dataset.hnStockChecked || '');
    const age = Date.now() - checkedAt;
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language || ''];
    const stock = Number(node.dataset.hnUsStock);
    const selectedId = form?.elements.namedItem('id')?.value;
    if (node.dataset.hnPending === 'true' || node.dataset.hnAvailable !== 'true' ||
        !selectedId || String(selectedId) !== node.dataset.hnVariant ||
        !Number.isFinite(stock) || stock < quantity || quantity < 1 ||
        !Number.isFinite(age) || age < -60000 || age > 900000 ||
        languages.some(lang => /^zh(?:-|$)/i.test(lang))) {
      hide(node);
      return;
    }
    const text = node.querySelector('[data-hn-eta-text]');
    if (!text) return hide(node);
    const format = (days) => {
      const date = new Date();
      date.setDate(date.getDate() + days);
      return date.toLocaleDateString(document.documentElement.lang || 'en', {month:'short', day:'numeric'});
    };
    const template = node.dataset.hnEtaTemplate;
    if (!template) return hide(node);
    text.textContent = template.replace('__START__', format(3)).replace('__END__', format(7));
    node.hidden = false;
    node.style.removeProperty('display');
  }
  function start() {
    nodes().forEach(refresh);
    document.addEventListener('input', () => nodes().forEach(refresh));
    document.addEventListener('change', () => nodes().forEach(refresh));
    document.addEventListener('shopify:section:load', () => nodes().forEach(refresh));
    setInterval(() => nodes().forEach(refresh), 30000);
    const pubsub = window.theme?.pubsub;
    if (!pubsub) return nodes().forEach(hide);
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      nodes().forEach(node => { node.dataset.hnPending = 'true'; hide(node); });
    });
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, ({data}) => {
      nodes().filter(node => node.dataset.hnSection === String(data.sectionId) &&
        node.dataset.hnProduct === String(data.productId)).forEach(node => {
        const replacement = [...data.parsedHTML.querySelectorAll(selector)].find(other =>
          other.dataset.hnSection === node.dataset.hnSection &&
          other.dataset.hnProduct === node.dataset.hnProduct && other.dataset.hnSlot === node.dataset.hnSlot);
        if (!replacement) return hide(node);
        ['hnUsStock','hnStockChecked','hnAvailable','hnVariant','hnEtaTemplate'].forEach(key => {
          node.dataset[key] = replacement.dataset[key] || '';
        });
        delete node.dataset.hnPending;
        refresh(node);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
